import SVPPattern from "./../../Images/PNG/Halftone-Effect-Background.png";
const SVGPattern = () => {
    return <img src={SVPPattern} alt="a" />;
};
export default SVGPattern;
